<template>
  <div class="offline-container">
    <div class="offline-branding" :style="{ backgroundImage: 'url(' + require('@/assets/images/pitaya_wordmark_black.png') + ')' }"></div>

    <div class="offline-center-screen">
      <h1> Uh oh... </h1>
      <p> Looks like your internet connection is down. <br>Please reconnect to continue Pitaya-ing. </p>
      <b-button v-if="connectionOverride" @click="$emit('connectionOverridden')">Hide This Screen</b-button>

    </div>
  </div>
</template>

<script>
export default {
  name: "Offline",
  props: ["connectionOverride"]
};
</script>

<style>
  .offline-container {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
  }

  .offline-center-screen {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #777;
    font-size: 16pt;
  }

  .offline-branding {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 150px;
    height: 40px;
    position: fixed;
    left: 12px;
    top: 12px;
  }
</style>
